import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import MarbleDisplay from '../mmcommon/MarbleDisplay';
import UIAssetKeys from '../UIAssetKeys';
import box2d from '../managers/Box2dObj';
import SoundAssetKeys from '../SoundAssetKeys';

export default class MarbleDragCounter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    // Marble Drop box sprites
    this.box1 = null;
    this.box2 = null;
    this.box1Hint = null;
    this.box2Hint = null;
    this.hintDisplay = null;
    this.boxShadow = null;

    // Marble choices at bottom
    this.marbleMenu = [];
    this.marbleShadows = [];

    // Dragging props
    this.draggingMarble = null;
    this.isDragging = false; // Used for drag from menu, dragging from container can use it's own pressmove
    this.dragOffset = { x: 0, y: 0 };

    // Marble storage
    this.box1Marbles = [];
    this.box2Marbles = [];
    this.marbleTrash = []; // Store marbles going back so user can drag another before it returns

    this.hintContainer = this.scene.add.container();
    this.box1Hint = ABCyaPhaser.Graphics.addRoundedRect(0,0,320,200, 25, 0xffff00,this.hintContainer, { x: 0, y: 0 }, false);
    this.box1Hint.x = -5;
    this.box1Hint.y = 63;

    this.box2Hint = ABCyaPhaser.Graphics.addRoundedRect(0,0,320,200, 25, 0xffff00,this.hintContainer, { x: 0, y: 0 }, false);
    this.box2Hint.x = 320;
    this.box2Hint.y = 63;

    this.hintContainer.alpha = 0;

    this.lblMarbleCount = ABCyaPhaser.Text.addText(718,155, 42, 0x000000, FontKeys._BPreplay_Bold, '0', this.hintContainer, true).setOrigin(0.5);

    this.hintDisplay = ABCyaPhaser.Images.addImage(650, 83, UIAssetKeys._mm_assets_HintDisplay, this).setOrigin(0)
      .setScale(0.78);

    // Drop Boxes
    this.boxShadow = ABCyaPhaser.Images.addImage(-65, 210, UIAssetKeys._mm_assets_CounterBoxShadows, this).setOrigin(0);

    this.add(this.hintContainer);

    this.box1 = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._DropBox, this);
    this.box1.x = this.box1.width / 2;
    this.box1.y = this.boxShadow.y - this.box1.height / 2 + this.boxShadow.height / 2 - 6;

    this.box2 = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._DropBox, this);
    this.box2.x = 325 + this.box2.width / 2;
    this.box2.y = this.boxShadow.y - this.box2.height / 2 + this.boxShadow.height / 2 - 6;

    this.btnHint = ABCyaPhaser.Images.addImage(290, 135, UIAssetKeys._mm_assets_BtnHint, this).setOrigin(0)
      .setInteractive();
    this.btnHint.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.showHint, this);
    this.btnHint.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.hideHint, this);

    const marbleInfo = [
      { x: -200, y: 30, type: 9 },
      { x: -270, y: 30, type: 10 },
      { x: -200, y: 100, type: 1 },
      { x: -270, y: 100, type: 2 },
      { x: -200, y: 170, type: 4 },
      { x: -270, y: 170, type: 5 },
      { x: -1270, y: 170, type: 6 },
      { x: -1270, y: 170, type: 7 },
      { x: -1270, y: 170, type: Phaser.Math.Between(1,10) },
      { x: -1270, y: 170, type: 3 }
    ];
    const count = marbleInfo.length;
    for (let i = 0; i < count; i++) {
      const mi = marbleInfo[i];
      const item = new MarbleDisplay(this.scene, mi.type);
      const shadow = ABCyaPhaser.Images.addImage(mi.x + 95, mi.y + 65, UIAssetKeys._mm_assets_MarbleShadow, this).setOrigin(0);
      item.shadowGraphic = shadow;
      this.marbleShadows.push(shadow);
      item.x = mi.x + 120;
      item.y = mi.y + 40;
      item.setInteractive({ draggable: true });
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, () => this.menuMarbleSelect(item), this);
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, () => this.menuMarbleDrag(item), this);
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.menuMarbleRelease(item), this);

      this.marbleMenu.push(item);
      this.add(item);
    }
  }

  /**
   * 
   * @param {MarbleDisplay} menuMarble 
   * @returns 
   */
  menuMarbleSelect (menuMarble) {
    if (menuMarble.isGrabbed) {
      console.log('DOUBLE GRAB');
      return;
    }
    // eslint-disable-next-line no-param-reassign
    menuMarble.shadowGraphic.alpha = 0;
    // eslint-disable-next-line no-param-reassign
    menuMarble.alpha = 0;
    // eslint-disable-next-line no-param-reassign
    menuMarble.isGrabbed = true;
    const gMarble = new MarbleDisplay(this.scene, menuMarble.marbleType);
    // eslint-disable-next-line no-param-reassign
    menuMarble.grabbedMarbleRef = gMarble;

    gMarble.setOrigin(0.5);
    gMarble.origX = menuMarble.x + gMarble.width / 2;
    gMarble.x = gMarble.origX;
    gMarble.origY = menuMarble.y + gMarble.height / 2;
    gMarble.y = gMarble.origY;

    this.add(gMarble);
    gMarble.offsetX = -this.x;
    gMarble.offsetY = -this.y;
    if (!ABCyaLib.DEVICE_INFO.desktop) {
      gMarble.offsetY += -42;
    }
  }

  /**
   * 
   * @param {MarbleDisplay} menuMarble 
   */
  menuMarbleDrag (menuMarble) {
    const dragMarble = menuMarble.grabbedMarbleRef;

    dragMarble.x = this.scene.input.activePointer.x + dragMarble.offsetX;
    dragMarble.y = this.scene.input.activePointer.y + dragMarble.offsetY;
  }

  /**
   * 
   * @param {MarbleDisplay} menuMarble 
   */
  menuMarbleRelease (menuMarble) {
    /** @type {MarbleDisplay} */
    const dragMarble = menuMarble.grabbedMarbleRef;
    let placed = false;
    if (this.checkCollisionBox(dragMarble, this.box1)) {
      if (this.box1Marbles.length < 25) {
        placed = true;
        this.box1Marbles.push(dragMarble);
      }
    }
    else if (this.checkCollisionBox(dragMarble, this.box2)) {
      if (this.box2Marbles.length < 25) {
        placed = true;
        this.box2Marbles.push(dragMarble);
      }
    }
    dragMarble.disableInteractive();
    if (placed) {
      // Make sure it won't fall out
      if (dragMarble.x < 5) {
        dragMarble.x = 5;
      }
      else if (dragMarble.x > 295 && dragMarble.x < 314) {
        dragMarble.x = 295;
      }
      else if (dragMarble.x > 314 && dragMarble.x < 326) {
        dragMarble.x = 326;
      }
      else if (dragMarble.x > 613) {
        dragMarble.x = 613;
      }

      // box2d stuff
      dragMarble.body = box2d.createMarble(dragMarble);

      dragMarble.setInteractive({ draggable: true });
      dragMarble.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, () => this.pickupMarble(dragMarble), this);
      dragMarble.on(Phaser.Input.Events.GAMEOBJECT_DRAG, () => this.moveMarble(dragMarble), this);
      dragMarble.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.moveMarbleDone(dragMarble), this);
      this.lblMarbleCount.text = `${this.box1Marbles.length + this.box2Marbles.length}`;
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._PlacedSound, this.scene);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._RemovedSound, this.scene);
      ABCyaPhaser.Tweens.addTween(dragMarble, 660, { y: this.scene.scale.height + 50, scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.In, () => this.removeDraggedMarble(dragMarble));
      this.marbleTrash.push(dragMarble); // So we can drag another before this one returns
    }
    // eslint-disable-next-line no-param-reassign, no-multi-assign
    menuMarble.shadowGraphic.alpha = menuMarble.alpha = 1;
    // eslint-disable-next-line no-param-reassign
    menuMarble.isGrabbed = false;
    // eslint-disable-next-line no-param-reassign
    menuMarble.grabbedMarbleRef = null;
  }

  /**
   * 
   * @param {MarbleDisplay} marble 
   */
  pickupMarble (marble) {
    box2d.removeMarble(marble.body);
    // eslint-disable-next-line no-param-reassign
    marble.body = null;
    let index = this.box1Marbles.indexOf(marble);
    if (index >= 0) {
      this.box1Marbles.splice(index,1);
    }
    else {
      index = this.box2Marbles.indexOf(marble);
      this.box2Marbles.splice(index,1);
    }
    this.lblMarbleCount.text = `${this.box1Marbles.length + this.box2Marbles.length}`;
  }

  /**
   * 
   * @param {MarbleDisplay} dragMarble 
   */
  moveMarble (dragMarble) {
    dragMarble.setPosition(this.scene.input.activePointer.x + dragMarble.offsetX, this.scene.input.activePointer.y + dragMarble.offsetY);
  }

  /**
   * 
   * @param {MarbleDisplay} dragMarble 
   */
  moveMarbleDone (dragMarble) {
    let placed = false;
    if (this.checkCollisionBox(dragMarble, this.box1)) {
      if (this.box1Marbles.length < 25) {
        placed = true;
        this.box1Marbles.push(dragMarble);
      }
    }
    else if (this.checkCollisionBox(dragMarble, this.box2)) {
      if (this.box2Marbles.length < 25) {
        placed = true;
        this.box2Marbles.push(dragMarble);
      }
    }
    if (placed) {
      // Make sure it won't fall out
      if (dragMarble.x < 5) {
        // eslint-disable-next-line no-param-reassign
        dragMarble.x = 5;
      }
      else if (dragMarble.x > 295 && dragMarble.x < 314) {
        // eslint-disable-next-line no-param-reassign
        dragMarble.x = 295;
      }
      else if (dragMarble.x > 314 && dragMarble.x < 326) {
        // eslint-disable-next-line no-param-reassign
        dragMarble.x = 326;
      }
      else if (dragMarble.x > 613) {
        // eslint-disable-next-line no-param-reassign
        dragMarble.x = 613;
      }

      // box2d stuff
      // eslint-disable-next-line no-param-reassign
      dragMarble.body = box2d.createMarble(dragMarble);
      this.lblMarbleCount.text = `${this.box1Marbles.length + this.box2Marbles.length}`;
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._PlacedSound, this.scene);
    }
    else {
      dragMarble.disableInteractive();
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._RemovedSound, this.scene);
      ABCyaPhaser.Tweens.addTween(dragMarble, 660, { y: this.scene.scale.height + 50, scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.In, () => this.removeDraggedMarble(dragMarble));

      this.marbleTrash.push(dragMarble); // So we can drag another before this one returns
    }
  }

  /**
   * 
   * @param {MarbleDisplay} dragMarble 
   */
  removeDraggedMarble (dragMarble) {
    const index = this.marbleTrash.indexOf(dragMarble);
    dragMarble.destroy();
    this.marbleTrash.splice(index,1);
  }

  /**
   * 
   * @param {MarbleDisplay} obj1 
   * @param {Phaser.GameObjects.Image} obj2 
   * @returns 
   */
  checkCollisionBox (obj1, obj2) {
    let isHit = false;
    const b1 = obj1.getBounds();
    const b2 = obj2.getBounds();
    const xDist = obj1.x - obj2.x;
    let xCheck = b1.width / 2 + b2.width / 2;
    xCheck = xCheck;
    if (xDist > -xCheck && xDist < xCheck) {
      const yDist = obj1.y - obj2.y;
      let yCheck = b1.height / 2 + b2.height / 2;
      yCheck = yCheck - 25;
      if (yDist > -yCheck && yDist < yCheck) {
        isHit = true;
      }
    }
    return isHit;
  }

  showHint () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._hint_marble_math, this.scene);
    this.scene.tweens.killTweensOf(this.hintContainer);
    ABCyaPhaser.Tweens.addTween(this.hintContainer, 400, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }

  hideHint () {
    this.scene.tweens.killTweensOf(this.hintContainer);
    ABCyaPhaser.Tweens.addTween(this.hintContainer, 400, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  reset () {
    let i; let count;
    count = this.box1Marbles.length;
    for (i = 0; i < count; i++) {
      const marble = this.box1Marbles[i];
      box2d.removeMarble(marble.body);
      this.marbleTrash.push(marble);
      ABCyaPhaser.Tweens.addTween(marble, 800, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.removeDraggedMarble(marble));
    }
    count = this.box2Marbles.length;
    for (i = 0; i < count; i++) {
      const marble = this.box2Marbles[i];
      box2d.removeMarble(marble.body);
      this.marbleTrash.push(marble);
      ABCyaPhaser.Tweens.addTween(marble, 800, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.removeDraggedMarble(marble));
    }

    this.box1Marbles = [];
    this.box2Marbles = [];
    this.lblMarbleCount.text = `${this.box1Marbles.length + this.box2Marbles.length}`;
  }

  layoutRatio () {
    const marbleInfo = [
      { x: 0, y: 0, type: 1 },
      { x: 70, y: 0, type: 2 },
      { x: 140, y: 0, type: 3 },
      { x: 210, y: 0, type: 4 },
      { x: 280, y: 0, type: 5 },
      { x: 0, y: -70, type: 6 },
      { x: 70, y: -70, type: 7 },
      { x: 140, y: -70, type: Phaser.Math.Between(1,10) },
      { x: 210, y: -70, type: 9 },
      { x: 280, y: -70, type: 10 }
    ];
    const xoffset = 150;
    const yoffset = -10;

    const count = this.marbleMenu.length;
    for (let i = 0; i < count; i++) {
      const r = Phaser.Math.Between(1, 7);
      const mi = marbleInfo[i];
      const marble = this.marbleMenu[i];
      const shadow = this.marbleShadows[i];
      marble.x = mi.x + xoffset;
      marble.y = mi.y + yoffset + r;
      shadow.x = marble.x - marble.getBounds().width / 2;
      shadow.y = marble.y + marble.getBounds().height / 2;
    }
  }

  tick () {
    box2d.update();
    this.add(this.btnHint);
  }
}